import { Role } from "./role";

export interface IEventCreate {
    name: string;
    dateTime: string;
    link: string;
    guestRoles: string[];
}
export interface IEvent {
    _id: string;
    name: string;
    dateTime: string;
    link: string;
    owner: string;
    guestRoles: Role[];
    eventType: EventType;
    eventTags: string[];
}
export interface IEventUpdate {
    _id: string;
    name: string;
    dateTime: string;
    link: string;
    guestRoles: string[];
    eventType: EventType;
    eventTags: string[];
}

export const eventType = {
    EVENT: "event",
    DPO: "dpo",
} as const;

export type EventType = ValueOf<typeof eventType>;
